import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';

const WiesenHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const sections = [
    { id: 'hero', label: 'Start' },
    { id: 'geschichte', label: 'Geschichte' },
    { id: 'galerie', label: 'Bilder' },
    { id: 'aktivitaeten', label: 'Aktivitäten' },
    { id: 'kontakt', label: 'Kontakt' }
  ];

  const scrollToSection = (id: string) => {
    // If not on the main wiesen-info page, navigate there first
    if (location.pathname !== '/wiesen-info') {
      window.location.href = '/wiesen-info#' + id;
      return;
    }
    
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const scrollToTop = () => {
    // If not on the main wiesen-info page, navigate there first
    if (location.pathname !== '/wiesen-info') {
      window.location.href = '/wiesen-info';
      return;
    }
    
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 shadow-md z-50 backdrop-blur-sm" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <nav className="container mx-auto px-4 py-4" aria-label="Wiesen Navigation">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-4">
            {/* Wiesen Logo/Title */}
            <button 
              onClick={scrollToTop}
              className="text-2xl font-bold text-[var(--primary-color)] hover:opacity-80 transition-colors"
              aria-label="Zum Seitenanfang - Liederkranz Wiesen"
            >
              <h1 className="text-2xl font-bold">Liederkranz Wiesen</h1>
            </button>
          </div>
          
          <div className="flex items-center gap-4">
            {/* Theme Toggle */}
            <div className="hidden md:block"><ThemeToggle /></div>
            
            {/* Mobile menu button */}
            <button 
              className="md:hidden"
              style={{ color: 'var(--text-primary)' }}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-expanded={isMenuOpen}
              aria-controls="wiesen-mobile-menu"
              aria-label={isMenuOpen ? "Menü schließen" : "Menü öffnen"}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          {/* Desktop menu */}
          <div className="hidden md:flex space-x-8" role="navigation">
            {sections.map((section) => (
              <button 
                key={section.id}
                onClick={() => scrollToSection(section.id)}
                className="hover:text-[var(--primary-color)] transition-colors"
                style={{ color: 'var(--text-primary)' }}
                aria-label={`Zum Abschnitt ${section.label} scrollen`}
              >
                {section.label}
              </button>
            ))}
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div 
            id="wiesen-mobile-menu" 
            className="md:hidden mt-4 space-y-4"
            role="navigation"
          >
            {sections.map((section) => (
              <button 
                key={section.id}
                onClick={() => scrollToSection(section.id)}
                className="block w-full text-left px-4 py-2 hover:bg-[var(--primary-color)]/10 transition-colors"
                style={{ color: 'var(--text-primary)' }}
                aria-label={`Zum Abschnitt ${section.label} scrollen`}
              >
                {section.label}
              </button>
            ))}
            <div className="pt-4 border-t" style={{ borderColor: 'var(--border-color)' }}>
              <ThemeToggle />
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default WiesenHeader;